import { PATHS } from "@config/app.routing";

const getUrlData = (url: string) => {
  const data = {
    url,
    isClientApp: url.includes(`${PATHS.CLIENT_APP}#`),
    isAgentApp: url.includes(`${PATHS.AGENT_APP}#`),
    isWWWApp: false,
  };

  data.isWWWApp = !data["isClientApp"] && !data["isAgentApp"];

  return data;
};

export { getUrlData };
